import React from 'react';

import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut';
import { LoginProvider, useLoginContext } from './context';
import * as Interfaces from './interfaces';

/**
 * This component renderes when user is logged in the system
 */
const Consumer: React.FC = () => {
  const context = useLoginContext();
  return context.isLoggedIn ? <LoggedIn /> : <LoggedOut />;
};

/**
 * This component renderes when user is logged in the system
 */
export const Login: React.FC<Interfaces.ComponentProps> = props => {
  return (
    <LoginProvider {...props}>
      <Consumer />
    </LoginProvider>
  );
};

export default Login;
